import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const embeddedPanelEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-embedded-confluence-panel" */ '.'),
	),
	getPreloadProps: () => ({}),
});
